import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Tag } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_dean_Chair_gooutlog,
  req_downloadfile_ssp_dean_Chair_gooutlog,
} from "../../api";

class DeanChairGooutLogList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    obj: {},
    colleges: [
      // { label: "管理學院", value: "管理學院" },
      { label: "民生暨管理學院", value: "民生暨管理學院" },
      { label: "設計學院", value: "設計學院" },
      { label: "藝術學院", value: "藝術學院" },
      // { label: "旅遊學院", value: "旅遊學院" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "七技", value: "七技" },
    ],
    sourceCodes: [
      { value: "AA", label: "商管群(A)" },
      { value: "AB", label: "餐旅群(A)" },
      { value: "AC", label: "設計群(A)" },
      { value: "AD", label: "藝術群(A)" },
      { value: "AE", label: "機械群(A)" },
      { value: "AF", label: "食品群(A)" },
      { value: "AG", label: "土木群(A)" },
      { value: "AH", label: "外語群英語類(A)" },
      { value: "AI", label: "電子與電機群資電類(A)" },
      { value: "AJ", label: "家政群生活應用類(A)" },
      { value: "AK", label: "家政群幼保類(A)" },
      { value: "AM", label: "農業類(A)" },
      { value: "BA", label: "藝術單招(B1)" },
      { value: "BB", label: "特殊選才(B2)" },
      { value: "BC", label: "繁星入學(B3)" },
      { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      { value: "DA", label: "技優甄審(D)" },
    ],
    selectedCollege: "NONE",
    targetDepartmentCode: "NONE",
    searchField: "NONE",
    searchValue: "",
    totalPlan: 0,
    totalConfident: 0,
  };

  componentWillMount() {}

  //////////
  api_list_studentsource = async () => {
    const { planAcademicYear, searchField, searchValue, selectedCollege } =
      this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_dean_Chair_gooutlog(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.NumberOfPeople;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.NumberConfident;
      }, 0);
      this.setState({ data: items, totalPlan, totalConfident });
    } else {
      const items = [];
      this.setState({ data: items, totalPlan: 0, totalConfident: 0 });
    }
  };

  api_downloadfile_items = async () => {
    const { planAcademicYear, searchField, searchValue, selectedCollege } =
      this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    // download file data
    const fileUrl = await req_downloadfile_ssp_dean_Chair_gooutlog(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCollege,
      searchField,
      searchValue,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    // const { targetDepartmentCode } = this.state;
    // if (targetDepartmentCode === "NONE") {
    //   message.info("請選擇系所!!");
    // } else {
    //   this.api_list_studentsource();
    // }
    this.api_list_studentsource();
    //console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handleCollegeChange = (event) => {
    this.setState({
      selectedCollege: event.target.value,
      targetDepartmentCode: "NONE",
    });
    this.setTargetdeparts(event.target.value);
    //console.log(value);
  };

  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState({
      targetDepartmentCode: value,
    });
  };

  handleSelectChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchField: value,
    });
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  //////////
  render() {
    const {
      planAcademicYear,
      colleges,
      selectedCollege,
      data,
      loading,
      searchValue,
      searchField,
    } = this.state;
    const columns = [
      {
        title: "學院",
        responsive: ["lg"],
        dataIndex: "CollegeName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "主管職稱",
        responsive: ["lg"],
        dataIndex: "PositioinTwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "主管姓名",
        dataIndex: "U_UserName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "出訪日期",
        responsive: ["lg"],
        dataIndex: "AD_Date",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "出訪縣市",
        responsive: ["lg"],
        dataIndex: "AD_City",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "出訪學校",
        dataIndex: "AD_SchoolName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "出訪目的",
        responsive: ["lg"],
        dataIndex: "AD_Type",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "011": //生活科技學院
              textColor = "#789017";
              break;
            case "010": //生活科技學院
              textColor = "#789017";
              break;
            case "020": // 管理學院
              textColor = "#0061ae";
              break;
            case "021": // 管理學院
              textColor = "#0061ae";
              break;
            case "030": // 設計學院
              textColor = "#f08519";
              break;
            case "031": // 設計學院
              textColor = "#f08519";
              break;
            case "040": // 藝術學院
              textColor = "#e40082";
              break;
            case "041": // 藝術學院
              textColor = "#e40082";
              break;
            case "050": // 旅遊學院
              textColor = "#00706a";
              break;
            case "051": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "實訪認定",
        width: "70px",
        align: "center",
        render: (item) => {
          const { AD_IsGo } = item;
          return (
            <span style={{ fontWeight: 900 }}>
              <Tag color={AD_IsGo === "列計" ? "#87d068" : "#A9A9A9"}>
                {AD_IsGo === "列計" ? "可列計" : "不列計"}
              </Tag>
            </span>
          );
        },
      },
    ];

    return (
      <>
        <div className="form-group">
          <Input
            placeholder="規劃年度"
            style={{
              width: 55,
              height: 39,
              margin: "0 5px",
              color: "red",
            }}
            onChange={(event) =>
              this.setState({ planAcademicYear: event.target.value })
            }
            value={planAcademicYear}
            readOnly={true}
            disabled={true}
          />
          <select
            className="form-control"
            style={{
              width: "160px",
              display: "inline-block",
              // backgroundColor: "LightCyan",
            }}
            onChange={this.handleCollegeChange}
            value={selectedCollege}
          >
            <option key={"NONE"} value={"NONE"}>
              請選擇學院
            </option>
            {colleges.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            style={{ width: "180px", display: "inline-block" }}
            onChange={this.handleSelectChange}
            value={searchField}
          >
            <option key={"NONE"} value="NONE">
              其他條件
            </option>
            <option key={"U_UserName"} value="U_UserName">
              主管姓名
            </option>
            <option key={"AD_SchoolName"} value="AD_SchoolName">
              生源學校
            </option>
          </select>
          <Input
            placeholder="關鍵字"
            style={{
              width: 80,
              height: 39,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={searchValue}
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
          />
          <button
            className="btn btn-info"
            onClick={this.handle_data_refresh}
            style={{
              marginLeft: "2px",
              marginBottom: "6px",
              display: "inline-block",
            }}
          >
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px", marginBottom: "6px" }}>查詢</span>
          </button>
          <button
            className="btn btn-info"
            onClick={this.handle_data_refresh}
            style={{
              marginLeft: "2px",
              display: "inline-block",
              marginBottom: "6px",
            }}
          >
            <i className="fas fa-sync-alt"></i>
          </button>
          <button
            className="btn btn-info"
            onClick={() => this.handle_show_ui_modal("download", {})}
            style={{ marginLeft: "2px", marginBottom: "6px" }}
          >
            <i className="fas fa-cloud-download-alt"></i>
          </button>
        </div>

        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DeanChairGooutLogList);
